import { Record } from 'immutable'
import { Area, IArea } from './Area'

export interface ISpace {
  readonly associatedPropertyId: string
  readonly ceilingHeight: number
  readonly id: string
  readonly maxContiguous: number
  readonly minDivisible: number
  readonly noOfDockHighDoorsLoading: number
  readonly noOfDriveInGradeLevelDoors: number
  readonly noOfParkingSpaces: number
  readonly officeSF: number
  readonly parcelId: string
  readonly parcelNo: string
  readonly spaceAvailable: IArea
  readonly spaceDescription: string
  readonly spaceNo: string
}

const SpaceRecord = Record({
  associatedPropertyId: '',
  ceilingHeight: 0,
  id: '',
  maxContiguous: 0,
  minDivisible: 0,
  noOfDockHighDoorsLoading: 0,
  noOfDriveInGradeLevelDoors: 0,
  noOfParkingSpaces: 0,
  officeSF: 0,
  parcelId: '',
  parcelNo: '',
  spaceAvailable: new Area(),
  spaceDescription: '',
  spaceNo: '',
})

export class Space extends SpaceRecord implements ISpace {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new Space()
    }

    const { spaceAvailable, ...rest } = initialState

    return new Space({
      spaceAvailable: Area.fromJS(spaceAvailable),
      ...rest,
    })
  }

  public readonly associatedPropertyId: string
  public readonly ceilingHeight: number
  public readonly id: string
  public readonly maxContiguous: number
  public readonly minDivisible: number
  public readonly noOfDockHighDoorsLoading: number
  public readonly noOfDriveInGradeLevelDoors: number
  public readonly noOfParkingSpaces: number
  public readonly officeSF: number
  public readonly parcelId: string
  public readonly parcelNo: string
  public readonly spaceAvailable: Area
  public readonly spaceDescription: string
  public readonly spaceNo: string

  constructor(props?: Partial<Space>) {
    props ? super(props) : super()
  }
}
